import {
  get,
} from 'lodash';

function isPublished(record) {
  return !!get(record, 'released_at');
}

export default isPublished;
